<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">消息管理</div>
      <ZD-list-querys>
        <template slot="inputs">
          <div class="list-query-child-div flex">
            <div class="query-title-div">手机号</div>
            <div class="query-inputs-div flex-1">
              <el-input
                size="small"
                v-model="info.userPhone"
                placeholder="请输入内容"
                clearable
                @keyup.enter.native="getListData(pagination)"
              ></el-input>
            </div>
          </div>
        </template>
        <template slot="actions">
          <button class="common-bg-button" @click="getListData(pagination)">
            搜 索
          </button>
        </template>
      </ZD-list-querys>
      <!-- 表格 -->
      <div class="list-table">
        <ZD-table
          :tableColumns="pageConfig.listColumns"
          :tableData="tableData"
          :operates="operates"
          :tableConfig="pageConfig.tableConfig"
        ></ZD-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination
          :pagination="pagination"
          v-on:pageUpdate="getListData"
        ></ZD-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from './page-config'
export default {
  name: '',
  components: {},
  props: {},
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      pagination: pageConfig.pagination,
      tableData: [], //表格数据
      info: {}, //页码与搜索框
      operates: {
        width: 220,
        fixed: 'right',
        list: [],
      }, // 列操作按钮
    }
  },
  computed: {},
  watch: {},
  created() {
    this.init()
  },
  mounted() {},
  methods: {
    //   获取表单详情
    init() {
      this.getListData(this.pagination)
    },
    //获取数据
    getListData(val) {
      this.info.pageNum = val.current - 1
      this.info.pageSize = val.pageSize
      this.info.corpNo = this.$store.state.corpNo
      let _ = this
      _.$U.showLoading(_)
      _.$H.get(_, _.$A.massaage, _.info).then((res) => {
        _.tableData = res.data.data.content || []
        _.pagination.total = res.data.data.totalElements || 0
        _.$U.hideLoading(_)
      })
    },
  },
}
</script>

<style scoped lang="scss"></style>
